export type ActionButtonsWrapperProps = {
  primary: React.ReactNode;
  secondary?: React.ReactNode;
  skipPaddingTop?: boolean;
};

export const ActionButtonsWrapper = ({
  primary,
  secondary,
  skipPaddingTop,
}: ActionButtonsWrapperProps) => (
  <div
    className={`flex flex-col flex-nowrap items-center gap-1.5 px-2 py-2.5 lg:flex-row lg:justify-end ${skipPaddingTop ? 'pt-0' : ''}`}
  >
    <div className="lg:order-2">{primary}</div>
    {secondary && <div className="lg:order-1">{secondary}</div>}
  </div>
);
